import Api from "./HandleErrorApi";

class PaymentApi {
    api = new Api()

    /**
     * Проверка оплаты счёта
     * @param billId {number}
     * @returns {Promise<{
     *     payed: boolean,
     * }>}
     */
    getBillState(billId) {
        return this.api.get(sprintf('/payment/%d/state', billId));
    }

    async applyPromo(data)
    {
        return this.api.post('/payment/applyPromo', data)
    }

    async applyPartnerPayout(data)
    {
        return this.api.post('/payment/applyPartnerPayout', data)
    }
}

export default new PaymentApi();
